import { Avatar } from "primereact/avatar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { APP_NAME } from "../../constants";
import { useState } from "react";
import Error from "../common/Error";
import { TEXT_NORMAL, TEXT_TITLE } from "../../style";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";

export default function CardInputEmail({ identifier, setIdentifier, requestOTP }) {
    const [loading, setLoading] = useState();
    const [error, setError] = useState();

    const navigate = useNavigate();

    return (
        <>
            <div className="w-full flex flex-column lg:flex-row align-items-center  lg:justify-content-center lg:p-1 lg:gap-3">
                <img className="w-full lg:w-6" src="/images/banner.jpg" alt="banner" />
                <Card
                    title={APP_NAME}
                    className="mt-4"
                    pt={{
                        title: { className: classNames(TEXT_TITLE, "text-center") },
                        content: { className: "pb-0" },
                    }}
                >
                    <div className="flex flex-column align-items-center text-center w-full">
                        <Avatar icon="pi pi-user" size="large" shape="circle" />
                        <p className={`p-0 m-0 font-semibold mt-2 ${TEXT_NORMAL}`}>Verify Your User Credentials To Continue</p>

                        <div className="p-inputgroup mt-3 w-full">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-envelope"></i>
                            </span>
                            <InputText
                                autoFocus
                                placeholder="Email or Phone"
                                disabled={loading}
                                value={identifier || ""}
                                onInput={(e) => setIdentifier(e.target.value)}
                                invalid={error}
                                pt={{
                                    root: { className: TEXT_NORMAL },
                                }}
                            />
                        </div>
                        {error && <Error className="w-full p-2 justify-content-end" error={error} />}

                        <Button
                            onClick={() => requestOTP(setLoading, setError)}
                            className="w-full mt-3"
                            severity="warning"
                            icon="pi pi-arrow-right"
                            label="Continue With Email or Phone"
                            disabled={loading}
                            loading={loading}
                            pt={{
                                label: { className: TEXT_NORMAL },
                                icon: { className: TEXT_NORMAL },
                            }}
                        />
                        <Button
                            onClick={() => navigate("/contact-us")}
                            className="w-full mt-3"
                            severity="info"
                            icon="pi pi-phone"
                            iconPos="right"
                            label="Need Help ?"
                            disabled={loading}
                            loading={loading}
                            pt={{
                                label: { className: TEXT_NORMAL },
                                icon: { className: TEXT_NORMAL },
                            }}
                        />
                    </div>
                </Card>
            </div>
        </>
    );
}
